(function() {
  var getDevice = (function(){
    var ua = navigator.userAgent;
     if((ua.indexOf('iPhone') > 0 ||
           ua.indexOf('iPod') > 0 ||
           ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) ||
           ua.indexOf('Windows Phone') > 0) {
       return 'sp';
     } else {
       return 'pc';
     }
  })();

  var url = location.href ;
  var protocol = location.protocol ;

  $.ajax({
    url: protocol + "//tag-api.dmm.com/v1.0", //STG　時は　"//stg-tag-api.dmm.com/v1.0"
    type: "post",
    timeout : 5000,
    dataType: "json",
    xhrFields:{
      withCredentials: true
    },
    data: JSON.stringify({
      url: url,
      device: getDevice,
      login: 0,
      options: {'i3':'1', 'gtm':'1', 'aff':'0'} // i3とGTMを利用する場合
    }),
  })
  .done(function(data) {
    var _parentDiv = document.getElementById('tracking_area');
    var _tags = data.tags;
    _tags = _tags.replace(new RegExp('\\r?\\n', 'g'), '');

    if (_tags.match(new RegExp('<!-- i3 tag -->.*?<\/script>', 'mig'))) {
      _parentDiv.insertAdjacentHTML('beforeend', _tags.match(new RegExp('(<input\\sid="i3.*?)<script>', 'mi'))[1]);
      var _i3Script = document.createElement('script');
      _i3Script.innerHTML = _tags.match(new RegExp('<script>(.+?)<\/script>', 'mi'))[1];
      _parentDiv.insertBefore(_i3Script, null);
      _tags = _tags.replace(new RegExp('<!-- i3 tag -->.*?<\/script>', 'mi'), '');
    }

    if (_tags.match(new RegExp('<!-- affiliate tool bar -->.*?<\/div>', 'mig'))) {
      var _affWork = _tags.match(new RegExp('(<div\\sid="aff.*?<\/div>)', 'mi'))[1];
      var _affScript = document.createElement('script');
      _affScript.src = _affWork.match(new RegExp('<script src=\"(.*?)\".+?<\/script>', 'mi'))[1];
      _affScript.async = _affWork.match(new RegExp('(async)', 'mi')) ? true : false;
      _affWork = _affWork.replace(new RegExp('<script src=\"(.*?)\".+?<\/script>', 'mi'), '');
      _parentDiv.insertAdjacentHTML('beforeend', _affWork);
      var _affDiv = document.getElementById('affiliatetoolbarcss');
      _affDiv.insertBefore(_affScript, null);
      _tags = _tags.replace(new RegExp('<!-- affiliate tool bar -->.*?<\/div>', 'mi'), '');
    }

    var _scripts = _tags.match(new RegExp('(<script>|<script src=\".*?>).*?<\/script>', 'mig'));
    if (_scripts != null) {
      var _scriptData = [];
      for (var i = 0; i < _scripts.length; i++) {
        if (_scripts[i].match(new RegExp('<script>(.+?)<\/script>', 'mi'))) {
          _scriptData.push({
            'code': _scripts[i].match(new RegExp('<script>(.+?)<\/script>', 'mi'))[1],
            'src': '',
            'async': false
          });
        } else if (_scripts[i].match(new RegExp('<script src=\"(.*?)\".+?><\/script>', 'mi'))) {
          var _async = _scripts[i].match(new RegExp('(async)', 'mi')) ? true : false;
          _scriptData.push({
            'code': '',
            'src': _scripts[i].match(new RegExp('<script src=\"(.*?)\".+?<\/script>', 'mi'))[1],
            'async': _async
          });
        }
      }

      for (var i = 0; i < _scriptData.length; i++) {
        var _addScript = document.createElement('script');
        if (_scriptData[i].code !== '') {
          _addScript.innerHTML = _scriptData[i].code;
        } else if (_scriptData[i].src !== '') {
          _addScript.src = _scriptData[i].src;
          _addScript.async = _scriptData[i].async;
        }
        _parentDiv.insertBefore(_addScript, null);
      };
    }
  })
})();